import { render, staticRenderFns } from "./WorkshopAbsensiPeserta.vue?vue&type=template&id=36b3ad98&"
import script from "./WorkshopAbsensiPeserta.vue?vue&type=script&lang=js&"
export * from "./WorkshopAbsensiPeserta.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopAbsensiPeserta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports